// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1zty2","modal-with-message":"styles_modal-with-message__ioPam","modalWithMessage":"styles_modal-with-message__ioPam"};